<script setup lang="ts">
import { Content } from '@/types/Facet'

const props = defineProps<{
  fetchFacetContList: Content[]
}>()
</script>

<template>
  <ul class="cate-box">
    <li v-for="item in fetchFacetContList" :key="item.id">
      <a :href="`/cont/${item.urlWord}/`">
        <div class="cate-box-title">
          <span>{{ item.headline }}</span
          ><time :datetime="item.modifiedAt.toString()">{{
          $dayjs(item.modifiedAt).format("YYYY/MM/DD")
        }}</time>
        </div>
        <div class="cate-box-detail">
          <OrganismsCDNImg
            :id="item.id"
            :table-name="'image' in item ? item.image?.tableName : ''"
            :file-name="
              'image' in item ? '200x133_' + item.image?.fileName : ''
            "
            width="200"
            height="133"
            alt=""
          />
          <ClientOnly>
            <p>{{ item.lead.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '') }}</p>
          </ClientOnly>
        </div>
      </a>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
.cate-box {
  padding: 0 4%;

  li {
    border-top: 2px solid $colorBlue;

    &:not(:last-of-type) {
      margin: 0 0 3%;
    }

    a {
      padding: 0.8em 1.4em 0.8em 0.8em;
      border-bottom: 1px solid $colorGray;
      border-left: 1px solid $colorGray;
      border-right: 1px solid $colorGray;
      display: block;
      background: url(~/assets/images/arrow_right.png) no-repeat 98% center;
      background-size: 2% auto;
    }
  }
}

.cate-box-title {
  padding: 0 0 0.8em;
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: space-between;

  span {
    display: block;
    color: $colorDarkBlue;
    font-size: px(15.9);
    font-weight: 700;
  }

  time {
    padding: 0 0 0 0.5em;
    width: 20%;
    display: block;
    color: #999;
    font-size: px(10.9);
    text-align: right;
    box-sizing: border-box;
  }
}

.cate-box-detail {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: space-between;

  img {
    width: 32%;
    box-sizing: border-box;
  }

  p {
    padding: 0 0 0 3%;
    height: 6em;
    width: 68%;
    color: #333;
    font-size: px(12);
    overflow: hidden;
    box-sizing: border-box;
  }
}

@include media(pc) {
  .cate-box {
    padding: 0%;

    li {
      &:not(:last-of-type) {
        margin: 0 0 15px;
      }

      a {
        padding: 17px 34px 22px 22px;
        background: url(~/assets/images/arrow_right.png) no-repeat 98% center;
        background-size: 12px auto;

        &:hover {
          opacity: 0.7;
        }
      }
    }
  }

  .cate-box-title {
    padding: 0 0 0.9em;
    font-size: px(19.2);

    time {
      font-size: px(11.7);
    }
  }

  .cate-box-detail {
    img {
      width: 182px;
      height: 122px;
    }

    p {
      padding: 0 0 0 18px;
      width: 404px;
      height: 7.4em;
      font-size: px(15);
    }
  }
}
</style>
